import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { ecosystemPillars } from "@/mocks/ecosystemData";

export default function EcosystemPillars() {
  return (
    <section className="bg-tie-grey-light py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / Ecosystem Pillars
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
                Six Pillars of Collaborative Innovation
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
                TIE's ecosystem operates across six interconnected pillars, each contributing a distinct capability that together creates a complete innovation infrastructure.
              </p>
            </div>
          </ScrollReveal>

          {/* Pillars Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {ecosystemPillars.map((pillar, index) => (
              <ScrollReveal key={pillar.title} delay={index * 100}>
                <div className="group h-full p-5 md:p-6 rounded-xl bg-white border border-tie-grey-dark hover:border-tie-teal/30 hover:shadow-lg transition-all duration-300">
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-10 h-10 rounded-lg bg-tie-teal flex items-center justify-center shrink-0">
                      <i className={`${pillar.icon} text-white text-base`} />
                    </div>
                    <div className="text-right">
                      <p className="font-serif text-xl md:text-2xl font-bold text-tie-navy">
                        {pillar.stat}
                      </p>
                      <p className="text-xs text-tie-text-muted">{pillar.statLabel}</p>
                    </div>
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-tie-text-primary mb-2">
                    {pillar.title}
                  </h3>
                  <p className="text-sm text-tie-text-secondary leading-relaxed">
                    {pillar.description}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}